


















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSendPaymentScheduled extends Vue {

  // 入金予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  
  public counterpart: Common.Counterpart = null;
  public segment: Common.Segment = null;
  public slipType:number = null;
  public isIncludeBalanceZero:boolean = false;
  public startDate: Date = null;
  public endDate: Date = null;
  public hasLicenseCurrency: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.SendPaymentScheduledReportTemplateQuery = new Common.SendPaymentScheduledReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.slipType = 128;
    this.startDate = new Date().getCalendarDate();
    this.endDate = new Date().getCalendarDate();
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    (this.$refs.SendPaymentScheduledDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SendPaymentScheduledReportQuery = new Common.SendPaymentScheduledReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.counterpart = this.counterpart;
    query.segment = this.segment;
    query.slipType = this.slipType;
    query.isIncludeBalanceZero = this.isIncludeBalanceZero;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
